export const OTP_TIMER = 30;
export const KTO_SYMBOL = "kto";
